import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnUser } from '../user';
import { FmRoom } from './room';

export class FmInviteUsers extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  @Type(() => FmRoom)
  public room: FmRoom;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public name: string;

  @Expose()
  public meetingToken: string;

  @Expose()
  public status: string;

  @Expose()
  public friendlyName: string;

  @Expose()
  public isOwner: boolean;

  @Expose()
  public isExternal: boolean;

  @Expose()
  public isFususUser: boolean;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
